import { Group, Stack, Text } from '@mantine/core';

interface AuthInfoBoxProps {
  rows: [string, string][];
}

export const AuthInfoBox = ({ rows }: AuthInfoBoxProps) => (
  <Stack
    gap={10}
    w="100%"
    px={16}
    py={14}
    style={{
      borderRadius: 8,
      backgroundColor: 'var(--color-bg-canvas)',
      border: '1px solid var(--color-border-soft)'
    }}
  >
    {rows.map(([label, value]) => (
      <Group key={label} justify="space-between" wrap="nowrap">
        <Text fz={12} style={{ color: 'var(--color-text-secondary)' }}>
          {label}
        </Text>
        <Text fz={13} fw={600} style={{ color: 'var(--color-text-primary)' }}>
          {value}
        </Text>
      </Group>
    ))}
  </Stack>
);
